import React, { forwardRef } from 'react'
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  Grid,
  Grow,
  IconButton,
  Typography,
} from '@mui/material'
import { motion } from 'framer-motion'
import { toast } from 'react-toastify'
import { Close } from '@mui/icons-material'
import { QuestionContainer } from 'layouts/onboarding/QuestionContainer'
import CompletedOnboarding from 'components/CompletedOnboarding'
import { useOnboarding } from 'layouts/onboarding/hooks/useOnboarding'

const Transition = forwardRef(function Transition(props, ref) {
  return <Grow timeout={300} ref={ref} {...props} />
})

export default function QuestionModal({
  modalHeader = 'Complete Onboarding',
  completionStepProps,
  steps = [],
  customHandleNext,
  onClose,
}) {
  const {
    activeStep,
    animate,
    setAnimate,
    userNotification,
    StepComponent,
    stepComponentProps,
    required,
    handleBack,
    handleNext,
    isLastStep,
    isDisabled,
  } = useOnboarding({
    steps,
    updateUrlOnNavigation: false,
    transitionTimeout: 0,
    customHandleNext,
  })
  return (
    <Dialog
      open
      onClose={onClose}
      TransitionComponent={Transition}
      keepMounted
      fullWidth
      maxWidth={'md'}
      PaperProps={{
        sx: {
          overflow: { xs: 'auto', sm: 'visible' },
          margin: '16px',
          width: 'calc(100% - 32px)',
        },
      }}
    >
      <DialogContent sx={{ overflow: 'visible' }}>
        <motion.div
          key="scheduler"
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.95 }}
          transition={{ duration: 0.3, ease: 'easeInOut' }}
        >
          <Box
            sx={{
              justifyContent: 'space-between',
              position: 'relative',
              top: { xs: -8, sm: -64 },
            }}
          >
            <IconButton
              onClick={onClose}
              sx={{
                position: 'absolute',
                top: 0,
                right: { xs: -8, sm: -16 },
                color: '#fff',
                zIndex: 1,
                backgroundColor: '#000',
                '&:hover': {
                  backgroundColor: '#000',
                },
              }}
            >
              <Close />
            </IconButton>
          </Box>
          <Box pt={4} pb={{ xs: 0, sm: 2 }} px={2}>
            <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
              <Typography
                variant="headerTitle"
                sx={{
                  color: '#262627',
                  display: `${
                    steps[activeStep] === undefined ? 'none' : 'block'
                  }`,
                }}
              >
                {modalHeader}
              </Typography>
            </Box>
            <Grid item xs={12} data-testid="modalOnboarding">
              <QuestionContainer
                activeStep={activeStep}
                animate={animate}
                setAnimate={setAnimate}
                userNotification={userNotification}
                StepComponent={
                  steps[activeStep] === undefined
                    ? CompletedOnboarding
                    : StepComponent
                }
                stepComponentProps={stepComponentProps}
                completionStepProps={completionStepProps}
                required={required}
                handleBack={handleBack}
                handleNext={handleNext}
                isLastStep={steps[activeStep] === undefined}
                handleCompleteOnboarding={onClose}
                isDisabled={isDisabled}
                removeBottomPadding={true}
              />
            </Grid>
          </Box>
        </motion.div>
      </DialogContent>
    </Dialog>
  )
}
